import CacheEventType from './interfaces/CacheEventType';
import CacheMessage from './interfaces/CacheMessage';
import CacheInstallationState from './interfaces/CacheInstallationState';
import ServiceWorkerMessage from './interfaces/ServiceWorkerMessage';
import * as CacheProgressEvent from './cacheProgressEvents';

export default function cacheProgressEventDispatcher(
    windowObj: Window,
    state: CacheInstallationState,
    message: ServiceWorkerMessage
): void {
    if (message.cacheMessage != null) {
        if (message.targetClient == state.appName || message.targetClient == 'global') {
            let cacheMessage: CacheMessage = message.cacheMessage;
            switch (cacheMessage.cacheEvent) {
                case CacheEventType.Checking:
                    CacheProgressEvent.onChecking(cacheMessage);
                    break;
                case CacheEventType.Downloading:
                    CacheProgressEvent.onDownloading(cacheMessage);
                    break;
                case CacheEventType.Progress:
                    CacheProgressEvent.onProgress(state, cacheMessage);
                    break;
                case CacheEventType.Error:
                    CacheProgressEvent.onError(windowObj, state, cacheMessage);
                    break;
                case CacheEventType.Cached:
                    CacheProgressEvent.onCached(windowObj, state, cacheMessage);
                    break;
                case CacheEventType.NoUpdate:
                    CacheProgressEvent.onNoUpdate(windowObj, state, cacheMessage);
                    break;
                case CacheEventType.Obsolete:
                    CacheProgressEvent.onObsolete(windowObj, state, cacheMessage);
                    break;
                case CacheEventType.UpdateReady:
                    CacheProgressEvent.onUpdateReady(windowObj, state, cacheMessage);
                    break;
                case CacheEventType.Idle:
                    CacheProgressEvent.onIdle(cacheMessage);
                    break;
                case CacheEventType.UnCached:
                    CacheProgressEvent.onUnCached(cacheMessage);
                    break;
                case CacheEventType.CleanupError:
                    CacheProgressEvent.onCleanupError(state, cacheMessage);
                    break;
                case CacheEventType.CleanupSuceeded:
                    CacheProgressEvent.onCleanupSuceeded(state, cacheMessage);
                    break;
            }
        }
    }
}
